import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { NudgeTrackingSlice } from './nudge-tracking-types'

const INITIAL_STATE: NudgeTrackingSlice = {
  recurringNudge: {
    wasShown: false,
    wasAccepted: null,
  },
  dcfNudge: {
    wasShown: false,
    wasAccepted: null,
  },
}

const nudgeTrackingSlice = createSlice({
  name: 'nudgeTracking',
  initialState: INITIAL_STATE,
  reducers: {
    setRecurringNudgeShown: (state) => {
      state.recurringNudge.wasShown = true
    },
    setRecurringNudgeAccepted: (state, action: PayloadAction<boolean>) => {
      state.recurringNudge.wasAccepted = action.payload
    },
    setDcfNudgeShown: (state) => {
      state.dcfNudge.wasShown = true
    },
    setDcfNudgeAccepted: (state, action: PayloadAction<boolean>) => {
      state.dcfNudge.wasAccepted = action.payload
    },
  },
})

export default nudgeTrackingSlice
